import Util from './../../../libs/util'
const { ajax,globalModalContain } = Util
function http ({ url,type,params,fail,final }) {
    return new Promise((resolve,reject) => {
        ajax[type](url,params).then(
            res => {
                const { code, data,msg='' } = res.data || {}
                if(code===1) {
                    resolve(data)
                } else {
                    globalModalContain.$Modal.error({
                        title:'错误',
                        content: msg
                    })
                    reject(new Error(''))
                }
            }
        ).catch(() => {
            globalModalContain.$Modal.error({
                title:'错误',
                content: '网络错误'
            })
            if(fail) {
                fail()
            }
            reject(new Error('网络错误'))
        }).finally(() => {
            if(final) {
                final()
            }
        })
    })
}

// 获取group列表
export function getAllGroupApi (params,callBack) {
    return http({
        url: '/route_group/all',
        type:'get',
        final: callBack,
        params
  })
}

// 新增编辑列表
export function updateGroupApi (params,callBack) {
    return http({
        url: '/route_group/update',
        type:'post',
        final:callBack,
        params
  })
}

// 获取人员列表
export function getGroupCustomersApi (params,callBack) {
    return http({
        url: '/route_group/customers',
        type:'get',
        final:callBack,
        params:{ params }
  })
}
// 获取ap列表
export function getGroupAppListApi (params,callBack) {
    return http({
        url: '/route_group/route_apps',
        type:'get',
        final:callBack,
        params:{ params }
  })
}
// 新增群组人员
export function addCustomersApi (params,callBack) {
    const { type,...other } = params
    // type 1 表示添加 2 表示删除
    return http({
        url: type ===1?'/route_group/add_customers':'/route_group/del_customers',
        type:'post',
        final:callBack,
        params:other
  })
}
// 获取app列表
export function getAppRouterListApi (params,callBack) {
    return http({
        url: '/route_app/list',
        type:'get',
        final:callBack,
        params
  })
}

// 获取app menus
export function getAppTreeApi (params,{ final,fail }) {
    return http({
          url: '/route_app/detail',
          type:'get',
          final,
          fail,
          params:{ params }
    })
}

// 新增items
export function updateMenuItemsApi (params,callBack) {
    if(params.add_item_ids) {
        return http({
            url: '/route_group/edit_app_route_menu_items',
            type:'post',
            final:callBack,
            params
        }) 
    }
    return http({
          url: '/route_group/edit_app_route_menu_items',
          type:'post',
          final:callBack,
          params
    })
}

// 获取该组已选择的权限
export function getSelectItemApi (params,{ final,fail }) {
    return http({
        url: '/route_group/app_route_menu_items',
        type:'get',
        final,
        fail,
        params:{ params }
    })
}